/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

import { cssMap as cssMapCompiled, jsx } from '@compiled/react';

import { fg } from '@atlaskit/platform-feature-flags';

import CreateTeamOnBoardingSVG from '../icons/CreateTeamOnBoardingSVG';

import * as Styled from './styled';

const DEFAULT_WIDTH = 237;
const DEFAULT_HEIGHT = 271;
const WIDE_WIDTH = 300;
const WIDE_HEIGHT = 343;

// TODO: After ptc-people-teams-migrate-styled-components FF cleanup:
// - Remove wrapper pattern (fg() conditionals) and use css={} directly
// - Remove Styled imports and styled.ts references
const compiledStyles = cssMapCompiled({
	svgWrapperBase: {
		height: 'auto',
	},
});

export default function CreateTeamIcon({ wide }: { wide?: boolean }): React.JSX.Element {
	const width = wide ? WIDE_WIDTH : DEFAULT_WIDTH;
	const height = wide ? WIDE_HEIGHT : DEFAULT_HEIGHT;

	// TODO: Remove wrapper after ptc-people-teams-migrate-styled-components FF cleanup
	const SvgContainer = fg('ptc-people-teams-migrate-styled-components')
		? (props: React.HTMLAttributes<HTMLDivElement> & { wide?: boolean }) => (
				<div
					css={compiledStyles.svgWrapperBase}
					style={{ width: `${props.wide ? WIDE_WIDTH : DEFAULT_WIDTH}px` }}
					{...props}
				/>
			)
		: Styled.SvgWrapper;

	return (
		<SvgContainer data-testid="create-team-internal-default-image-content" aria-hidden wide={wide}>
			<CreateTeamOnBoardingSVG width={width} height={height} />
		</SvgContainer>
	);
}
